import React from 'react'
import { Grid, Icon, Segment, Tab, Table, Divider } from 'semantic-ui-react'
import { Redirect } from 'react-router-dom'
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

import moment from 'moment'

import './Student.css'

const data = [
  {
    name: '2016', grade: 93, classAverage: 88,
  },
  {
    name: '2017', grade: 96, classAverage: 92,
  },
  {
    name: '2018', grade: 94, classAverage: 90,
  },
  {
    name: '2019', grade: 94, classAverage: 89,
  }
];

const StudentPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' || props.userType === 'staff' || props.userType === 'cashier') {
    const panes = [
      { menuItem: 'Demographics', render: () =>
        <Tab.Pane>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Name</strong>
                </Table.Cell>
                <Table.Cell><span>{props.student.lastName}, {props.student.firstName} {props.middleName}</span></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Gender</strong>
                </Table.Cell>
                <Table.Cell>{props.student.gender}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Place of Birth</strong>
                </Table.Cell>
                <Table.Cell>{props.student.placeOfBirth}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Birthdate</strong>
                </Table.Cell>
                <Table.Cell>{moment(props.student.birthDate).format('MMM DD, YYYY')}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Religion</strong>
                </Table.Cell>
                <Table.Cell>{props.student.religion}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
      { menuItem: 'Contact Information', render: () =>
        <Tab.Pane>
          <h3>Personal Contact Information</h3>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Address</strong>
                </Table.Cell>
                <Table.Cell>{props.student.address}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Email</strong>
                </Table.Cell>
                <Table.Cell>{props.student.email}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Mobile 1</strong>
                </Table.Cell>
                <Table.Cell>{props.student.mobile1}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Mobile 2</strong>
                </Table.Cell>
                <Table.Cell>{props.student.mobile2}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <h3>Contact Information in case of Emergency</h3>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Contact Person</strong>
                </Table.Cell>
                <Table.Cell>{props.student.contactPerson}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Contact Person Number</strong>
                </Table.Cell>
                <Table.Cell>{props.student.contactPersonNumber}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Contact Person Address</strong>
                </Table.Cell>
                <Table.Cell>{props.student.contactPersonAddress}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
      { menuItem: 'Guardian', render: () =>
        <Tab.Pane>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Name</strong>
                </Table.Cell>
                <Table.Cell>{props.student.guardianName}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Contact Number</strong>
                </Table.Cell>
                <Table.Cell>{props.student.guardianNumber}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Address</strong>
                </Table.Cell>
                <Table.Cell>{props.student.guardianAddress}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
      { menuItem: 'Medical', render: () =>
        <Tab.Pane>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Have Been Hospitalized?</strong>
                </Table.Cell>
                <Table.Cell>{props.student.beenHospitalized ? 'Yes' : 'No' }</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Reason</strong>
                </Table.Cell>
                <Table.Cell>{props.student.hospitalReason}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Medical History</strong>
                </Table.Cell>
                <Table.Cell>{props.student.medicalHistory}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
      { menuItem: 'Portfolio', render: () =>
        <Tab.Pane>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8}>
                <h3>About Me</h3>
                <Table basic='very' celled size='small'>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>Happy go lucky person. Likes to hangout with my friends!</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
                <Divider />
                <h3> Awards and Badges</h3>
                  <Table basic='very' celled size='small'>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell collapsing>
                          <Icon name='lab' /> <strong>Best in Science</strong>
                        </Table.Cell>
                        <Table.Cell>SY 2019-2020</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell collapsing>
                          <Icon name='calculator' /> <strong>Best in Math</strong>
                        </Table.Cell>
                        <Table.Cell>SY 2019-2020</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell collapsing>
                          <Icon name='handshake' /> <strong>Most Friendly</strong>
                        </Table.Cell>
                        <Table.Cell>SY 2018-2019</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
              </Grid.Column>
              <Grid.Column width={8}>
                <h3> Grades Summary</h3>
                  <LineChart
                    width={550}
                    height={380}
                    data={data}
                    margin={{
                      top: 5, right: 30, left: 20, bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="grade" stroke="#8884d8" activeDot={{ r: 8 }} />
                    <Line type="monotone" dataKey="classAverage" stroke="#82ca9d" />
                  </LineChart>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Tab.Pane>
      },
      { menuItem: 'Classes', render: () => <Tab.Pane>Under Development</Tab.Pane> },
      { menuItem: 'Violations', render: () => <Tab.Pane>Under Development</Tab.Pane> }
    ]
    return (
        <Grid centered>
          <Grid.Row className='student-back-grid-row'>
            <Grid.Column width={16}>
              <span className='menu-text' onClick={() => props.goBack()}>
                <Icon name='arrow left' />Back to List
              </span>
                <Icon className='menu-icon' name='times'
                  style={{float:'right'}} onClick={() => props.goBack()}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Segment>
              <div className='student-name-div'>
                <Icon name='user' size='large'/>
                <span className='student-name'>{props.student.lastName}, {props.student.firstName} ({props.student.nickName})</span>
                <span className='student-lrn'>Student #: {props.student.studentNumber} </span> <br/>
                <span className='student-lrn'>LRN: {props.student.lrn? props.student.lrn : "--"} </span>
              </div>
              <Tab panes={panes} />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
    )
  } else {
    return <Segment>You are not authorized to be in this page.</Segment>
  }
  } else {
    return <Redirect to='/' />
  }

}

export default StudentPV;
